/**
 * Build a human-readable location subtitle for a golf club.
 * Returns city (preferred) or state, never country / country_code.
 * Returns an empty string when no useful disambiguator is available.
 */
export function formatClubLocation(club) {
  if (!club || typeof club !== 'object') return '';
  const parts = [club.city, club.state].filter(
    (p) => typeof p === 'string' && p.trim().length > 0
  );
  return parts.join(', ');
}
